export default "__VITE_ASSET__BtCV6YCk__"